import React from 'react';
import { SAuthLayoutFooterWrapper, SAuthLayoutHeaderWrapper, SLayout, SLayoutContent, SLayoutInner } from './AuthLayout.styles';
import { AuthLayoutFooter } from './AuthLayoutFooter/AuthLayoutFooter';
import { AuthLayoutHeader } from './AuthLayoutHeader/AuthLayoutHeader';
import { Outlet } from 'react-router-dom';
import { Col, Row } from 'antd';

export const AuthLayout: React.FC = () => {
  return (
    <SLayout>
      <SAuthLayoutHeaderWrapper>
        <AuthLayoutHeader />
      </SAuthLayoutHeaderWrapper>
      <SLayoutInner>
        <Row justify={'center'} style={{ width: '100%' }}>
          <Col style={{ display: 'flex', flexDirection: 'column' }} xs={{ span: 22 }} md={{ span: 12 }} lg={{ span: 12 }}>
            <SLayoutContent>
              <Outlet />
            </SLayoutContent>
            <SAuthLayoutFooterWrapper>
              <AuthLayoutFooter />
            </SAuthLayoutFooterWrapper>
          </Col>
        </Row>
      </SLayoutInner>
    </SLayout>
  );
};
